export default __webpack_public_path__ + "static/media/ecash-logo-horizontal.3e9ecd15.png";